import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { http, scrollToId } from "@/lib/api";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Bento } from "@/components/site/Bento";
import { Catalog } from "@/components/site/Catalog";
import { Manifesto } from "@/components/site/Manifesto";
import { TopSales } from "@/components/site/TopSales";
import { Journal } from "@/components/site/Journal";
import { Faq, Newsletter } from "@/components/site/Sections";

export default function Home() {
  const [products, setProducts] = useState([]);
  const [collection, setCollection] = useState(null);
  const { hash } = useLocation();

  useEffect(() => {
    http.get("/products")
      .then((r) => setProducts(Array.isArray(r.data) ? r.data : []))
      .catch(() => setProducts([]));
  }, []);

  useEffect(() => {
    if (!hash) return;
    const t = setTimeout(() => scrollToId(hash.slice(1)), 350);
    return () => clearTimeout(t);
  }, [hash, products.length]);

  const pick = (c) => {
    setCollection(c);
    setTimeout(() => scrollToId("catalogue"), 50);
  };

  return (
    <div data-testid="home-page">
      <Hero />
      <Marquee />
      <Bento onPick={pick} products={products} />
      <Catalog products={products} collection={collection} setCollection={setCollection} />
      <TopSales />
      <Manifesto />
      <Journal />
      <Newsletter />
      <Faq />
    </div>
  );
}
